<template>
  <article id="article-search">
    <div>
      <!-- Search Box -->
      <section
        id="section-search-box"
        :class="[ isToggleSearch ? 'is-searching' : '', isSticky ? 'sticky-top' : 'remove-sticky-top']"
      >
        <div class="search-group">
          <h1 v-if="!isToggleSearch">{{ searchTitle }}</h1>
          <div class="search-row" :class="[isToggleSearch? 'is-focusing': '']">
            <div class="search-box">
              <text-input
                data-action="start_search"
                @toggle-search="toggleSearch()"
                @is-searching="value => isSearching = value"
                @isLoading="value => isLoading = value"
                :text-searching.sync="searchText"
                @mixins_global_search_orderSearchScore="value => mixins_global_search_orderSearchScore = value"
                @mixins_global_search_searchResults="value => mixins_global_search_searchResults = value"
                @mixins_global_search_allTab_notFound="value => mixins_global_search_allTab_notFound = value"
              />
            </div>
            <div class="search-action" v-if="isToggleSearch">
              <a
                @click="closeSearch"
                data-action="close_search"
                href="javascript:;"
                class="cancel-focus"
              >ยกเลิก</a>
            </div>
          </div>
        </div>
      </section>
      <!-- Search Box -->

      <!-- Fund Trending -->
      <fund-trending v-if="!isToggleSearch" />
      <!-- Fund Trending -->

      <!-- Stock Trending -->
      <!-- <stock-trending v-if="!isToggleSearch" /> -->
      <!-- Stock Trending -->

      <!-- History Search -->
      <history
        @click-history="clickHistory"
        v-if="!isLoading && isToggleSearch && !isSearching && !searchText"
      />
      <!-- History Search -->

      <!-- Search Loading -->
      <section id="search-loading" v-if="isLoading">
        <i class="loading fas fa-spinner-third fa-spin"></i>
      </section>

      <!-- Search Result -->
      <result
        v-if="!isLoading && isToggleSearch && isSearching && searchText && searchText.length !== 0"
        :searchText="searchText"
        :mixins_global_search_orderSearchScore.sync="mixins_global_search_orderSearchScore"
        :mixins_global_search_searchResults.sync="mixins_global_search_searchResults"
        :mixins_global_search_allTab_notFound="mixins_global_search_allTab_notFound"
      />
      <!-- Search Result -->
    </div>
  </article>
</template>
<script>
const Result = () => import("../../components/miniapp/search/Result");
const TextInput = () => import("../../components/miniapp/search/TextInput");
const FundTrending = () =>
  import("../../components/miniapp/search/FundTrending");
const StockTrending = () =>
  import("../../components/miniapp/search/StockTrending");
const History = () => import("../../components/miniapp/search/History");

export default {
  components: {
    TextInput,
    FundTrending,
    StockTrending,
    History,
    Result
  },
  data() {
    return {
      searchTitle: "Search Fund/Stock",
      mixins_global_search_orderSearchScore: [],
      mixins_global_search_searchResults: [],
      mixins_global_search_allTab_notFound: false,
      searchText: "",
      isToggleSearch: false,
      isSearching: false,
      isLoading: false,
      isSticky: false
    };
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  watch: {
    $route() {
      this.$route.query.toggleSearch
        ? (this.isToggleSearch = true)
        : (this.isToggleSearch = false);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.$route.query.toggleSearch
      ? (this.isToggleSearch = true)
      : (this.isToggleSearch = false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      currentScrollPosition > 0
        ? (this.isSticky = true)
        : (this.isSticky = false);
    },
    toggleSearch() {
      this.isToggleSearch = true;
    },
    closeSearch() {
      this.isToggleSearch = false;
      this.isSearching = false;
      this.searchText = "";
    },
    clickHistory(values) {
      this.isToggleSearch = true;
      this.isSearching = true;
      this.searchText = values.text;
    }
  }
};
</script>
<style lang="scss" scoped>
#article-search {
  background-color: #ffffff;
  height: -webkit-fill-available;
  h1 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    font-size: 20px;
    color: $color-normal-text;
    margin: 0;
    margin-bottom: 10px;
  }
  #section-search-box {
    @extend %container-style;
    z-index: 2;
    background-color: $color-white;
    border-bottom: 1px solid $color-border;
    height: 125px;
    display: table;
    transition: height 0.2s linear;
    .search-group {
      display: table-cell;
      vertical-align: middle;
      .is-focusing {
        .search-box {
          @include finCol(10, 12, 16px, middle, true, true);
        }
        .search-action {
          @include finCol(2, 12, 16px, middle, true, true);
          text-align: center;
          padding: 0 16px;
          .cancel-focus {
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: $color-secondary-text;
            text-decoration: none;
          }
        }
      }
    }
  }
  .is-searching {
    height: 80px !important;
  }
  #search-loading {
    @extend %container-style;
    text-align: center;
    vertical-align: middle;
    .loading {
      text-align: center;
      font-size: 32px;
      margin: 50px auto auto;
      color: #bababa;
    }
  }
  #section-trending-fund {
    @extend %container-style;
    overflow-x: hidden;
  }
  .sticky-top {
    position: sticky;
    top: 0px;
    z-index: 1;
    // height: 80px !important;
  }
  .remove-sticky-top {
    position: relative;
  }
}
</style>